import React, { Component } from 'react'
import Draggable from 'react-draggable';

import classNames from './OrchestraArrange.css'

export default class OrchestraArrangePlayer extends Component {
  state = {
    loaded: false,
    x_pos: this.props.left,
    y_pos: this.props.top
  }
  componentDidMount () {
  }
  componentWillUnmount () {
  }
  handleStop = (e, data) => {
    let pos = {
      x_pos: data.x,
      y_pos: data.y
    };
    this.setState(pos, () => this.props.onPlayerMove(this.props.id, pos));
  }
  handleStart = (e, data) => {
    this.props.onPlayerClicked(this.props.id);
  }
  render () {
    let className = this.props.connected ? [classNames.player] : [classNames.player, classNames.inactive]
    if (this.props.selected) { className.push(classNames.selected) }
    return (
        <Draggable
          onStop={this.handleStop}
          onStart={this.handleStart}
          bounds={'parent'}
          position={this.props.position}
        >
          <div className={className} style={this.props.style}>
            <div>id: {this.props.id}</div>
            <div>{this.props.width}x{this.props.height}</div>
          </div>
        </Draggable>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/orchestra/OrchestraArrangePlayer.js